import { Component } from '@angular/core';
import { LoaderService } from '@shared/services/loader.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-already-processed',
    templateUrl: './already-processed.component.html',
    styleUrls: ['./already-processed.component.css'],
    standalone: false
})
export class AlreadyProcessedComponent {

  constructor(private _loaderService: LoaderService) {}

  ngOnInit(): void {
    this._loaderService.hideLoading();
  }
}
